import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";

export type HandlerType = Parameters<typeof PopulateApiParameter>[0];

addToChainAfter(chain, PopulateApiParameter, SetSelectedCollectAccount);

function SetSelectedCollectAccount(props: HandlerType) {
    const selectedCarrier = props.parameter.carrier;
    let collectAccountValue = "";
    if (selectedCarrier.collectAccount) {
        collectAccountValue = selectedCarrier.collectAccount;
    }
    props.apiParameter.cart = {
        ...props.apiParameter.cart,
        properties: {
            ...props.apiParameter.cart.properties,
            collectAccount: collectAccountValue,
        },
    };
}
